'use client';

import { useStore } from '@/providers/app-store-provider';
import dynamic from 'next/dynamic';
import { ELoginRegisterCloseType } from './types';
const LoginRegister = dynamic(() => import('./GlobalLoginRegister'), {
  ssr: false,
});

/**
 * 全局登录注册弹窗组件
 * 通过 global store 状态管理显示与隐藏
 */
export default function GlobalLoginRegister() {
  const showLoginRegisterDialog = useStore((state) => state.showLoginRegisterDialog);
  const loginRegisterEventType = useStore((state) => state.loginRegisterEventType);
  const onLoginClose = useStore((state) => state.onLoginClose);
  const setShowLoginRegisterDialog = useStore((state) => state.setShowLoginRegisterDialog);
  const setOnLoginClose = useStore((state) => state.setOnLoginClose);

  const handleUpdateShow = (show: boolean) => {
    if (!show) {
      setShowLoginRegisterDialog(false);
    } else {
      setShowLoginRegisterDialog(true);
    }
  };

  const handleClose = (type?: ELoginRegisterCloseType) => {
    setShowLoginRegisterDialog(false);
    onLoginClose?.(type);
    setOnLoginClose(() => {});
  };

  return (
    <LoginRegister
      show={showLoginRegisterDialog}
      eventType={loginRegisterEventType}
      onUpdateShow={handleUpdateShow}
      onClose={handleClose}
    />
  );
}
